var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"prepend-icon":"fact_check","items":_vm.items,"label":_vm.$t('cobrox.factura.labels.estado'),"loading":_vm.loading,"error":_vm.hasInputErrors('estado'),"error-messages":_vm.getInputErrors('estado'),"color":"secondary","item-color":"secondary"},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }